module.exports = __webpack_public_path__ + "img/MIGRATION.7274782c.svg";